module.exports = __webpack_public_path__ + "media/src/application/media/img_parallax-bc4b1a02ba0c7094504bb2afa1720a7d.webp";